module.exports = __webpack_public_path__ + "static/media/story2.3b5b0edf.jpg";